import { createFileRoute } from "@tanstack/react-router";

import { LegalDocLayout, type LegalTocItem } from "@/components/legal/LegalDocLayout";
import {
  TERMS_ARTICLES,
  TERMS_EFFECTIVE_DATE,
  TERMS_LAST_UPDATED,
  TERMS_PREAMBLE,
} from "@/content/terms";

import { seoHead } from "@/lib/seo";

export const Route = createFileRoute("/terms")({
  head: () => seoHead({
    title: "利用規約 - KAGEM",
    description: "KAGEMサービスの利用規約。アカウント、コンテンツ、料金、知的財産、禁止事項、責任範囲などの条件を定めています。日本法準拠、東京地方裁判所を専属管轄とします。",
    path: "/terms",
  }),
  component: TermsPage,
});

function TermsPage() {
  const toc: LegalTocItem[] = TERMS_ARTICLES.map((a) => ({
    id: a.id,
    label: `第${a.number}条 ${a.title}`,
  }));

  return (
    <LegalDocLayout
      title="利用規約"
      preamble={TERMS_PREAMBLE}
      lastUpdated={TERMS_LAST_UPDATED}
      effectiveDate={TERMS_EFFECTIVE_DATE}
      toc={toc}
    >
      {TERMS_ARTICLES.map((article) => (
        <section key={article.id} id={article.id} className="legal-section scroll-mt-24">
          <h2 className="mb-3 text-lg font-semibold sm:text-xl">
            第{article.number}条({article.title})
          </h2>

          {article.paragraphs?.map((p, i) => (
            <p key={`p-${i}`} className="mb-3 text-sm leading-relaxed text-foreground/90">
              {p}
            </p>
          ))}

          {article.items && article.items.length > 0 && (
            <ol className="mb-3 ml-5 list-decimal space-y-1.5 text-sm leading-relaxed text-foreground/90 marker:text-muted-foreground">
              {article.items.map((item, i) => (
                <li key={`i-${i}`}>{item}</li>
              ))}
            </ol>
          )}

          {article.trailing?.map((p, i) => (
            <p key={`t-${i}`} className="mb-3 text-sm leading-relaxed text-foreground/90">
              {p}
            </p>
          ))}
        </section>
      ))}
    </LegalDocLayout>
  );
}
